import { LocationInterface, LocationUpdateParamsInterface } from 'interfaces/location.interface';
import { useDispatch, useSelector } from '@ecommerce/nest-ssr/common';
import { LocationActions } from '../reducers/location.reducer';
import { updateLocation } from 'helpers/update-location.helper';

interface UseLocationInterface {
    location: LocationInterface;
    getUpdatedLocation: (params: LocationUpdateParamsInterface) => LocationInterface;
    updateLocation: (params: LocationUpdateParamsInterface) => void;
}

export const useLocation = (): UseLocationInterface => {
    const dispatch = useDispatch();

    const location = useSelector(
        (state: { location: LocationInterface; }) => state.location
    );

    const getUpdatedLocation = (params: LocationUpdateParamsInterface): LocationInterface => updateLocation(location, params);

    const update = (params: LocationUpdateParamsInterface): void => {
        dispatch({
            type: LocationActions.UpdateLocation,
            payload: params
        });
    };

    return { location, getUpdatedLocation, updateLocation: update };
};
